import { render, staticRenderFns } from "./letter_of_recommendation.vue?vue&type=template&id=4db7d596&scoped=true&"
import script from "./letter_of_recommendation.vue?vue&type=script&lang=js&"
export * from "./letter_of_recommendation.vue?vue&type=script&lang=js&"
import style0 from "./letter_of_recommendation.vue?vue&type=style&index=0&id=4db7d596&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db7d596",
  null
  
)

export default component.exports